/**
 * Returns a promise that resolves once the grecaptcha
 * script is loaded
 * @return {Promise}
 */
export const loadGrecaptcha = function () {
    // Promisifying the loading of grecaptcha
    if (window.grecaptcha)
        return Promise.resolve();

    return new Promise((resolve, reject) => {
        import('./../captcha')
            .then((captcha) => {
                const script = document.createElement('script');
                script.setAttribute('async', '');
                script.setAttribute('defer', '');

                const publicKey = captcha.getRecaptchaV3PublicKey();
                script.src = `https://www.google.com/recaptcha/api.js?hl=ru&render=${publicKey}`;

                script.onload = () => {
                    resolve();
                };
                script.onerror = () => {
                    reject(new Error('Error loading grecaptcha'));
                };

                const head = document.getElementsByTagName('head')[0];
                head.appendChild(script);
            })
            .catch(() => reject(new Error('Could not import captcha module')));
    });
};
